import React, { useCallback, useEffect, useState } from 'react';
import { Button, Form, Input, notification, Space, Spin } from 'antd';
import ReviewScoreVisualisation from '../../common/components/reviews_visualisation/ReviewScoreVisualisation';
import { useSubmitReviewMutation } from '../fisherySlice';

const { TextArea } = Input;

export default function NewReviewForm({ fisheryUUID, onSuccess = () => {} }) {
  const [score, setScore] = useState(0);
  const [submitReview, { isLoading: isReviewRequestPending }] =
    useSubmitReviewMutation();

  const subheadingClasses = 'sb-blue fs-16 gSemiBold';

  const [form] = Form.useForm();

  const updateFormValue = useCallback(
    (nameValuePair) => {
      if (!form) {
        return;
      }
      const values = form.getFieldsValue(true);
      form.setFieldsValue({ ...values, ...nameValuePair });
    },
    [form]
  );

  /**
   * Required as rating (stars) selector is not a standard HTML/AntD form item
   */
  useEffect(() => {
    if (!form) {
      return;
    }
    updateFormValue({ score: score || null });
  }, [form, score, updateFormValue]);

  const handleServerError = (err) => {
    if (err.response) {
      if (err.response.status !== 401 && err.response.status !== 200) {
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Error submitting review',
        });
      } else if (err.response.status === 401) {
        notification.error({
          message: <div className='gSemiBold'>There was an issue!</div>,
          style: { border: '1px #D34545 solid' },
          placement: window?.innerWidth <= 500 ? 'bottom' : 'topRight',
          className: 'gRegular br10',
          description: 'Please log in to leave a fishery review.',
        });
      }
    }
  };

  const onFormSubmit = async (values) => {
    const { score, comments } = values;
    if (!score) {
      return;
    }

    submitReview({ fishery_id: fisheryUUID, score, comments })
      .unwrap()
      .then(onSuccess)
      .catch(handleServerError);
  };

  return (
    <Form onFinish={onFormSubmit} form={form} onValuesChange={updateFormValue}>
      <h3 className={subheadingClasses}>Select your fishery rating</h3>
      <Form.Item
        name={'score'}
        rules={[
          {
            required: true,
            message: 'Please select a rating',
          },
        ]}
      >
        <Space direction={'horizontal'}>
          <ReviewScoreVisualisation
            score={score}
            onClick={setScore}
            interactive
          />
          <span className={'gBold fs-18'}>{score}/5</span>
        </Space>
      </Form.Item>
      <h3 className={subheadingClasses + 'mg-top-20'}>Leave your review</h3>
      <Form.Item
        name={'comments'}
        rules={[
          {
            required: true,
            message: 'Please enter a review',
          },
        ]}
      >
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item>
        {isReviewRequestPending ? (
          <div className={'w-full txt-center'}>
            <Spin />
          </div>
        ) : (
          <Button
            htmlType='submit'
            className={
              'light-green-bg gSemiBold br10 fs-20 white txt-center w-full pd-10 mg-bottom-10 h-fit'
            }
          >
            Submit
          </Button>
        )}
      </Form.Item>
    </Form>
  );
}
